module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAYAAAB2pebxAAAA8klEQVR42q2STW7CQAyFn52069wAjsANCMtm1ZwAIiDbXqGXqKJONM0RQEIJy/YIHIEjhG1g4i5alb8KMdF4M3qy/Sx/Y8B16KycaLUubtXk2Sq8rGEXwwkAPvLqUwShdTPJ5tAg8fNsFbYAZmlEtib5e/nqPfALM7hPQtsua3CLrTMm/s8jz1pVYYf+AMDy14SW0/Qp6XIS8GjoZJ0rE62qhXorB/fqf00EgOGm/tOE4Exf5E/AHmOWRvGZnkejW3lnX+yeSVEsgisGtkySJK4BjKyZCJuaIP1u9849QbvzvUfzZfb+WKtKbD0E7WZvmvgbYwt5zqd0yK8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/Booking/calendar-blue.png
// module id = 491
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 24